import {Column} from '@tanstack/react-table';

export const handleSortingClick = <T>(column: Column<T>) => {
    column.toggleSorting();
    column.columnDef.meta?.sortingFn?.();
};
